import React, { useState, useMemo } from "react";
import { Line } from "react-chartjs-2";

const LineChart = ({ graphData = [] }) => {
  const [colorMap, setColorMap] = useState({});
  const [selectedColors, setSelectedColors] = useState({});

  // Generate random color
  const generateColor = () => {
    return "#" + Math.random().toString(16).substr(-6);
  };

  // Ensure unique colors for each dataset
  const newColorFind = (id) => {
    if (colorMap[id]) return colorMap[id];

    let newColor;
    do {
      newColor = generateColor();
    } while (selectedColors[newColor]);

    setColorMap((prev) => ({ ...prev, [id]: newColor }));
    setSelectedColors((prev) => ({ ...prev, [newColor]: true }));

    return newColor;
  };

  // Compute datasets and labels
  const { labels, datasets } = useMemo(() => {
    if (!graphData || graphData.length === 0) {
      return { labels: [], datasets: [] };
    }

    const firstItem = graphData[0];
    const labels = [...(firstItem?.label || [])]; // clone to prevent mutation

    const datasets = graphData.map((item, key) => {
      const clr = newColorFind(key);
      return {
        label: item?.type,
        fill: false,
        backgroundColor: clr,
        borderColor: clr,
        data: [...(item?.data || [])], // clone for safety
      };
    });

    return { labels, datasets };
  }, [graphData]);

  const data = { labels, datasets };

  return (
    <div className="chart">
      <Line
        data={data}
        options={{ maintainAspectRatio: false }}
      />
    </div>
  );
};

export default LineChart;
